<template>
    <div class="process">

        <div class="product boxRow">
            <div class="product-name">
                {{name}} Luce
            </div>
            <div>
                <strong>Costo Energia Luce Mono</strong>
                {{f}} €/kWh
            </div>
            <div>
                <strong>Costo Energia Luce F1</strong>
                {{f1}} €/kWh
            </div>
            <div>
                <strong>Costo Energia Luce F2-F3</strong>
                {{f2}} €/kWh
            </div>
            <div>
                <strong>Residente</strong>
                {{resident}}
            </div>
            <div>
                <strong>Stima annua Monoraira</strong>
                {{stimaAnnuaMonoraria}} €/kWh
            </div>
            <div>
                <strong>Stima annua Bioraria</strong>
                {{stimaAnnuaBioraria}} €/kWh
            </div>
        </div>

        <div class="partials boxRow">
            <div>
                
                <strong>Prezzo Materia Energia</strong>
                ( energia * consumo * perdite + PD * consumo + PCV + DISPbt + PPE ) IVA ridotta<br>
                ( {{f}} * {{consumo}} * {{perdite}} + {{PD}} * {{consumo}} + {{PCV}} + {{DISPbt}} + {{PPE}} ) * {{Iva.ridotta}}
                <div class="result">
                    {{prezzoMateriaEnergiaMonoraria}} €/anno
                </div>
            </div>
            <div>
                <strong>Prezzo Materia Energia Bioraria</strong>
                ( energiaF1 * consumoF1 * perdite + energiaF2 * consumoF2 * perdite + PD * consumo + PCV + DISPbt + PPE ) IVA ridotta<br>
                ( {{f1}} * {{consumoF1}} * {{perdite}} + {{f2}} * {{consumoF2}} * {{perdite}} + {{PD}} * {{consumo}} + {{PCV}} + {{DISPbt}} + {{PPE}} ) * {{Iva.ridotta}}
                <div class="result">
                    {{prezzoMateriaEnergiaBioraria}} €/anno
                </div>
            </div>
            <div>
                <strong>Trasporto</strong>
                ( prezzo * consumo + canone + prezzo-potenza * potenza ) * IVA ridotta<br>
                ( {{trasporto.prezzo}} * {{consumo}} + {{trasporto.canone}} + {{trasporto.prezzoPotenza}} * {{potenza}} ) * {{Iva.ridotta}}
                <div class="result">
                    {{prezzoTrasporto}} €/anno
                </div>
            </div>
            <div>
                <strong>Oneri</strong>
                ( prezzoOneri * consumo<span v-if="!resident"> + canone</span> ) * IVA ridotta<br>
                ( {{oneri.prezzo}} * {{consumo}}<span v-if="!resident"> + {{oneri.canone}}</span>) * {{Iva.ridotta}}
                <div class="result">
                    {{prezzoOneri}} €/anno
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { EnergyCosts } from "../model/Costs.js";
import Iva from "../model/Iva.js";

export default {
    name: "Luce",
    props: {
        product: {},                    //- potenza impianto utente ---
        potenza: Number,                //- potenza impianto utente ---
        consumoF1: Number,              //- consumo annuo dichiarati dall'utente ---
        consumoF2: Number,              //- consumo annuo dichiarati dall'utente ---
        resident: Boolean,              //- regione appartenenza ---
    },
    data() { 
        return {
            loaded: false,
            prezzo: {
                materiaMonoraria: 0,
                materiaBioraria: 0,
                trasporto: 0,
                oneri: 0,
                accisa: 0,
                totale: 0
            },
            perdite: 1.104,
            PD: 0.01388, 
            DISPbt: -13.983,
            trasporto: {
                prezzo: 0,
                canone: 0,
                prezzoPotenza: 0
            },
            oneri: {
                prezzo: 0,
                canone: 0
            },
            Iva: {
                intera: 0,
                ridotta: 0
            },
            name: 0,                  //- prezzo materia prima ---
            f: 0,                  //- prezzo materia prima ---
            f1: 0,                 //- prezzo materia prima ---
            f2: 0,                 //- prezzo materia prima ---
            PCV: 0,                    //- custom EGL PCV --- scontocerto 120 --- sceltasicura quella dell'autorità
            PPE: 0,                     //- mercato libero residenziale
        };
    },
    mounted() {
        console.log( 'Luce mounted', this.consumo, this.potenza, this.resident, this.product );
        console.log( 'Luce mounted energy cost', EnergyCosts );

        //- Taxes ---
            this.Iva.intera = Iva.intera;
            this.Iva.ridotta = Iva.ridotta;

        //- Products variables ---
            this.name = this.product.name;
            this.f = this.product.f;
            this.f1 = this.product.f1;
            this.f2 = this.product.f2;
            this.PCV = this.product.PCV;

        //- Power variables ---
            this.perdite = EnergyCosts.perdite;
            this.PD = EnergyCosts.PD;
            this.DISPbt = EnergyCosts.DISPbt;
            this.PPE = (this.product.PPE) ? EnergyCosts.PPE : 0;
            this.oneri = EnergyCosts.oneri;
            this.trasporto = EnergyCosts.trasporto;

        //- Energy ---
            this.prezzo.materiaMonoraria = this.prezzoMateriaEnergiaMonoraria;
            this.prezzo.materiaBioraria = this.prezzoMateriaEnergiaBioraria;
        //- Transport ---
            this.prezzo.trasporto = this.prezzoTrasporto;
        //- Charges ---
            this.prezzo.oneri = this.prezzoOneri;

        //- Annual cost ---
            this.prezzo.totaleMonoraria = this.stimaAnnuaMonoraria;
            this.prezzo.totaleBioraria = this.stimaAnnuaBioraria;
            
    },
    computed: {
        consumo: function(){
            return this.consumoF1 + this.consumoF2;
        },

        prezzoMateriaEnergiaMonoraria: function(){
            return ( this.f * this.consumo * this.perdite + this.PD * this.consumo + this.PCV + this.DISPbt + this.PPE ) * this.Iva.ridotta;
        },

        prezzoMateriaEnergiaBioraria: function(){
            return ( this.f1 * this.consumoF1 * this.perdite + this.f2 * this.consumoF2 * this.perdite + this.PD * this.consumo + this.PCV + this.DISPbt + this.PPE ) * this.Iva.ridotta;
        },

        //- Trasporto ---
            prezzoTrasporto: function(){
                return ( this.trasporto.prezzo * this.consumo + this.trasporto.canone + this.trasporto.prezzoPotenza * this.potenza ) * this.Iva.ridotta;
            },
        //- Oneri ---
            prezzoOneri: function(){
                return ( this.oneri.prezzo * this.consumo + ( this.resident ? 0 : this.oneri.canone ) ) * this.Iva.ridotta;
            },
        //- Costo all'utente ---
            stimaAnnuaMonoraria: function(){
                return this.prezzo.materiaMonoraria + this.prezzo.trasporto + this.prezzo.oneri;
            },

            stimaAnnuaBioraria: function(){
                return this.prezzo.materiaBioraria + this.prezzo.trasporto + this.prezzo.oneri;
            }
    },
    methods: {
        // mancano delle regioni sopratuttto nella Addizionale regionale
        // nell'addizionale la lombardia è esclusa come da nota sotto la tabella?
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hide {opacity: 0;}

    .boxRow {
        display: flex; font-size: 12px; 
    }

    .boxRow > div {
        background: #FFF4BC; border: 1px solid #FFE978; padding: 15px; margin-bottom: 15px; 
    }

    .boxRow.product strong {
        display: block; margin-bottom: 9px;
    }

    .boxRow > .product-name {
        font-size: 27px; line-height: 38px;
    }

    .boxRow.scaglioni > div >>> span {
        display: inline-block; width: 150px;
    }
    
    .boxRow.scaglioni > div { 
        
    }

    .boxRow.partials {
        flex-direction: column; margin-bottom: 75px; max-width: 1140px;
    }

    .boxRow.partials > div {
        position: relative; margin-bottom: 0; line-height: 17px;
    }

    .boxRow.partials > div > strong {
        display: block; margin-bottom: 9px;
    }

    .boxRow.partials > div .result {
        background: #FFE978; margin: 0; font-size: 16px; font-weight: 600; padding: 15px;

        width: 250px; position: absolute; right: 0; top: 0; bottom: 0; 
    }

    .boxRow.partials > div .result strong {
        font-size: 12px; margin-bottom: 9px; text-transform: uppercase; font-weight: 600; display: block;
    }

    .boxRow.partials > div .result::before { 
        content: '+'; border-radius: 50%; background: #fff; line-height: 20px; width: 20px; text-align: center; position: absolute; bottom: 0; transform: translateY(50%);
        z-index: 50;
    }

    .boxRow.partials > div:last-child .result::before { 
        content: '';
    }

    .tooltip {
        position: relative; display: inline-block;
    }

    .tooltip > span { display: none; padding: 9px;
        position: absolute; bottom: 50px; left: 50%; width: 300px; background: #333; color: #fff;
    }

    .tooltip:hover > span { display: block; }
</style>